import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { isNullOrEmptyString } from '../../../../shared/utils.js';
import { isNullOrUndefined } from 'util';

import { CLPUser, OfficeCodes, TeamCodes } from '../../../models/clpuser.model';
import { CompanyResponse } from '../../../models/company.model';
import { eMailingCategory, eUserPermissions, eUserRole } from '../../../models/enum.model';
import { SimpleResponse } from '../../../models/genericResponse.model';
import { LCCheckedInRequest, LiveConnectSettingResponse, LiveConnectt, EmailBoxResponse, EmailBox, eEmailBoxStatus, eEmailBoxProcessor, EmailBoxSuppressListResponse, EmailBoxSuppress } from '../../../models/live-connect.model';
import { VoiceRecording } from '../../../models/voiceRecordings.models';
import { AppConfig } from '../../../models/appConfig.model';
import { CustomSearchResponse } from '../../../models/report.model';
import { SearchItemListResponse, keyValue } from '../../../models/search.model';
import { NotificationService } from '../../../services/notification.service';

import { AccountSetupService } from '../../../services/accountSetup.service';
import { LiveConnectService } from '../../../services/live-connect.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { GlobalService } from '../../../services/global.service';
import { AppconfigService } from '../../../services/shared/appconfig.service';
import { SearchContactService } from '../../../services/Searchcontact.service';
import { ReportService } from '../../../services/report.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { LocalService } from '../../../services/shared/local.service';

@Component({
    selector: 'lc-setting-ignore-list',
    templateUrl: './lc-setting-ignore-list.component.html',
    styleUrls: ['./lc-setting-ignore-list.component.css']
})
/** lc-setting-form component*/
export class LcSettingIgnoreListComponent {
    /** lc-setting-form ctor */
    @ViewChild(MatPaginator) paginator: MatPaginator;
    suppressionSource: MatTableDataSource<any>;
    suppressionDisplayColumns: string[];
    @ViewChild(MatSort) sort: MatSort;
    columns = [
        { field: 'emails', title: 'Email Addresses To Ignore', width: '40' },
        { field: 'domains', title: 'Domains To Ignore', width: '250' },
    ]

    isShowSettings: boolean = false;
    liveSettingForm: FormGroup;
    @Input() user: CLPUser;
    @Input() isFromLiveConnect: boolean = false;
    isShowViewMode: boolean = true;
    encryptedUser: string = "";
    liveConnectId: number = 0;
    officeCodes: OfficeCodes[];
    teamCodes: TeamCodes[];
    officeCodesSRS: OfficeCodes[];
    teamCodesSRS: TeamCodes[];
    voiceRecordDD: VoiceRecording[];
    isLoadWithSRS: boolean = false;
    isLoadWithoutSRS: boolean = false;
    isShowSetupAccoutBtn: boolean = false;
    warningMsg: string = "";
    isSRSManager: boolean = false;
    isSRS: boolean = false;
    isSlurrpyForLiveConnect: boolean = false;
    isShowButtons: boolean = true;
    liveConnectt: LiveConnectt = <LiveConnectt>{};
    @Input() lcCheckedInRequestObj: LCCheckedInRequest = <LCCheckedInRequest>{};
    myHomeUrl: string = "";
    emailBox: EmailBox = {
        emailBoxID: 0,
        clpCompanyID: 0,
        clpUserID: 0,
        inboxAddress: '',
        appPassword: '',
        imapServer: 'imap.gmail.com',
        imapPort: 993,
        isAddLiveConnectCard: false,
        searchMethod: 0,
        isAutoAIPopulate: false,
        customSearchID: 0,
        processor: 0,
        isMoveToHandledFolder: false,
        handledFolderName: '_EngageProcessed',
        toProcessFolderName: '_EngageReProcess',
        isMarkUnhandledAsRead: false,
        ageMinutesToProcess: 0,
        status: 0,
        dtLastRun: '',
    };

    ddcustomsearch: CustomSearchResponse[] = [];
    customsearch: CustomSearchResponse = <CustomSearchResponse>{};
    searchContactCount: string = "";
    ebConnectText: string = "Connect";
    ebShowDetails: boolean = false;
    ebShowConnectDetails: boolean = true;
    ebShowPasswords: boolean = true;
    savedQuery_Filter: keyValue[] = [];
    selectedSearch: string = '';
    showSavedSearch: boolean = false;
    suppressDomainList: EmailBoxSuppress[] = [];
    suppressEmailList: EmailBoxSuppress[] = [];

    constructor(private fb: FormBuilder,
        private _router: Router,
        private _globalService: GlobalService,
        private _accountSetupService: AccountSetupService,
        private _localService: LocalService,
        private _appConfigService1: AppconfigService,
        private _searchContactService: SearchContactService,
        private _reportService: ReportService,
        private notifyService: NotificationService,
        private _utilityService: UtilityService, private _liveConnectSrvc: LiveConnectService) {

    }

    ngOnInit() {
        this.liveSettingForm = this.prepareLiveSettingForm();
        this._localService.getDefaultHome(this.encryptedUser)
            .then(async (result: AppConfig) => {
                if (result) {
                    this.myHomeUrl = result.homeURL;
                }
            });
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                if (this.user) {
                    this.setUp();
                }
                else {
                    window.location.href = this.myHomeUrl;
                }
            }
            else {
                window.location.href = this.myHomeUrl;
            }
        })
    }

    async setUp() {
        this.isShowViewMode = true;
        this.isLoadWithoutSRS = false;
        this.isLoadWithSRS = false;
        await this.liveConnect_isLiveConnectSRSAccount();
        this.isSlurrpyForLiveConnect = (this.user?.slurpyUserId > 0 || this.isSRSManager) ? true : false;
        if (this.user?.permissions == eUserPermissions.Active) {
            if (!isNullOrEmptyString(this.user?.txtMsgLongCode)) {
                await this.liveConnect_LoadByUser();

                if (!isNullOrUndefined(this.liveConnectt) && this.liveConnectt?.liveConnectID > 0) {
                    this.liveConnectId = this.liveConnectt.liveConnectID;
                    if (this.liveConnectt?.isActive) {
                        this.isShowSettings = true;
                        this.isLoadWithoutSRS = true;
                    }
                    if (this.liveConnectt?.isSRSActive) {
                        if (this.liveConnectt?.srsCLPCompanyID > -1) {
                            if (this.isSlurrpyForLiveConnect) {
                                this.isLoadWithSRS = true;
                            }
                        }
                    }
                }
                await this.emailBox_LoadByCLPUser();
                this.loadSuppressList();

            } else {
                this.warningMsg = "User does not have a Long Code Number.";
                this.isShowButtons = false;
            }
        } else {
            this.warningMsg = "User does not look Active.";
            this.isShowButtons = false;
        }
    }

    async loadSuppressList() {
        if (this.emailBox.emailBoxID > 0) {
            this.liveSettingForm.get("inboxAddress").setValue(this.emailBox.inboxAddress);
            await this.emailBoxSuppress_GetListEmails(this.emailBox.emailBoxID, "false")
            await this.emailBoxSuppress_GetListDomain(this.emailBox.emailBoxID, "true")
            this.setGrid();
        }
        else {
            this.emailBox.inboxAddress = this.user?.email;
        }
    }

    async liveConnect_isLiveConnectSRSAccount() {
        await this._liveConnectSrvc.liveConnect_isLiveConnectSRSAccount(this.encryptedUser, this.user?.cLPCompanyID)
            .then(async (result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.isSRS = result?.messageBool;
                    this.isSRSManager = (result?.messageBool && this.user.userRole > eUserRole.Manager) ? true : false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.liveConnect_isLiveConnectSRSAccount", err.message, null, 'cLPCompanyID ' + this.user?.cLPCompanyID + 'cLPUserID ' + this.user.cLPUserID + 'slurpyUserId ' + this.user?.slurpyUserId);
                this._utilityService.handleErrorResponse(err);
            });
    }

    prepareLiveSettingForm() {
        return this.fb.group({
            inboxAddress: new FormControl('')
        });
    }

    async liveConnect_LoadByUser() {
        await this._liveConnectSrvc.liveConnect_LoadByUser(this.encryptedUser, this.user?.cLPUserID)
            .then(async (result: LiveConnectt) => {
                if (!isNullOrUndefined(result)) {
                    this.liveConnectt = result;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.liveConnect_LoadByUser", err.message, null, 'cLPUserID ' + this.user.cLPUserID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async emailBox_LoadByCLPUser() {
        this.ebShowDetails = false;
        await this._liveConnectSrvc.emailBox_LoadByCLPUser(this.encryptedUser, this.user?.cLPUserID)
            .then(async (result: EmailBoxResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.emailBox = result.emailBox;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.emailBox_LoadByCLPUser", err.message, null, 'cLPUserID ' + this.user.cLPUserID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async emailBoxSuppress_GetListEmails(intEmailBoxID: number, strblnDomains: string = "") {
        this.ebShowDetails = false;
        await this._liveConnectSrvc.emailBoxSuppress_GetList(this.encryptedUser, intEmailBoxID, strblnDomains)
            .then(async (result: EmailBoxSuppressListResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.suppressEmailList = result?.emailBoxSuppressList;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.emailBox_LoadByCLPUser", err.message, null, 'cLPUserID ' + this.user.cLPUserID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async emailBoxSuppress_GetListDomain(intEmailBoxID: number, strblnDomains: string = "") {
        this.ebShowDetails = false;
        await this._liveConnectSrvc.emailBoxSuppress_GetList(this.encryptedUser, intEmailBoxID, strblnDomains)
            .then(async (result: EmailBoxSuppressListResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.suppressDomainList = result?.emailBoxSuppressList;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.emailBox_LoadByCLPUser", err.message, null, 'cLPUserID ' + this.user.cLPUserID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    clearAllEmail() {
        if (this.emailBox?.emailBoxID > 0) {
            this.emailBoxSuppress_ClearList(this.emailBox?.emailBoxID, false);
        }
    }

    clearAllDomain() {
        if (this.emailBox?.emailBoxID > 0) {
            this.emailBoxSuppress_ClearList(this.emailBox?.emailBoxID, true);
        }
    }

    async emailBoxSuppress_ClearList(intEmailBoxID: number, blnDomains) {
        this.ebShowDetails = false;
        await this._liveConnectSrvc.emailBoxSuppress_ClearList(this.encryptedUser, intEmailBoxID, blnDomains)
            .then(async (result: EmailBoxSuppressListResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.loadSuppressList();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.emailBox_LoadByCLPUser", err.message, null, 'cLPUserID ' + this.user.cLPUserID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async emailBoxSuppress_Remove(emailBoxSuppressID) {
        this.ebShowDetails = false;
        await this._liveConnectSrvc.emailBoxSuppress_Remove(this.encryptedUser, emailBoxSuppressID)
            .then(async (result: EmailBoxSuppressListResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.loadSuppressList();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("lc-setting.emailBox_LoadByCLPUser", err.message, null, 'cLPUserID ' + this.user.cLPUserID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    liveConnectSave() {
        this.isShowViewMode = true;
    }

    showViewMode() {
        this.isShowViewMode = !this.isShowViewMode;
    }

    setGrid() {
        this.suppressionDisplayColumns = this.columns.map(c => c.field);
        let list = [{ emails: this.suppressEmailList, domains: this.suppressDomainList }]
        console.log(list)
        this.suppressionSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.suppressionSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = 50;
            }
            if (this.sort) {
                this.suppressionSource.sort = this.sort;
            }
        }, 500)
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    ngOnDestroy() {
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }
}
